export function placeholderImage(image: any, placeholder: any) {
  return image ? image.url : placeholder;
}
